import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';
import ToastBase from './ToastBase';

const StyledComponent = styled<any, any>(
    ToastBase,
    'toastError',
    'feedback-toast'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderColor: '#f5c6cb',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastError.tsx